module.exports = __webpack_public_path__ + "static/media/arrow_up_black.1f8e2e08.svg";